/** 提现 */
<template>
  <div class="exchange-list-wrap margin-top-20">
    <BasiceLayout
      title="过去7天收益"
      class="withdrawal-layout"
      empty-text="loading"
    >
      <ve-line :data="chartData" :extend="extend" :settings="chartSettings"></ve-line>
    </BasiceLayout>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import { Message } from "element-ui";
import moment from "moment";

export default {
  name: "AccountLayout",
  components: {
    BasiceLayout
  },
  data() {
    this.extend = {
      'xAxis.0.axisLabel.rotate': 45
    }
    return {
      chartData: [],
      chartSettings: {}
    };
  },
  props: {
    deviceId: ''
  },
  created() {
    this.getLastSevenRevenue().then(res => {
      if (res && res.data) {
        let data = res.data;
        let chartData = {
          // columns: ['日期', '当日总收益', '当日计算收益'],
          columns: ['日期', '当日总收益预估', '当日计算收益', '当日网络收益'],
          rows: []
        };
        for (let i in data) {
          let item = data[i];
          chartData.rows.push({
            '日期': moment(Number(i)).format('YYYY MM DD'),
            '当日总收益预估': item.bxc,
            '当日计算收益': item.compute_bxc,
            '当日网络收益': item.network_bxc,
          })
        }
        this.extend = {
          'xAxis.0.axisLabel.rotate': 45,
          // series: {
          //   label: {
          //     normal: {
          //       show: true
          //     }
          //   }
          // }
        }
        this.chartSettings = {
          scale: [true, true]
        }
        this.chartData = chartData;
      }
    });
  },
  methods: {
    ...mapActions(["getLastSevenRevenue"]),
    // 查看卡密
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
</style>

